// extracted by mini-css-extract-plugin
module.exports = {"buttons":"r_bf","button":"r_n"};